import { useEffect } from 'react';

const WIDGET_HEIGHT = '48px';

const ReviewsHorizontal = () => {
  useEffect(() => {
    if (window.Trustpilot) {
      const widgets = document.getElementsByClassName('trustpilot-widget');
      Array.from(widgets).forEach((widget) => {
        window.Trustpilot.loadFromElement(widget);
      });
    }
  }, []);

  return (
    <div
      className="trustpilot-widget"
      style={{ minHeight: WIDGET_HEIGHT }}
      data-locale="en-GB"
      data-template-id="5419b6ffb0d04a076446a9af"
      data-businessunit-id="61e6f3bfa6bec4c5bbb7a049"
      data-style-height={WIDGET_HEIGHT}
      data-style-width="90%"
    >
      <a
        href="https://uk.trustpilot.com/review/fantasyfootballhub.co.uk"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default ReviewsHorizontal;
